import { useEffect, useState } from 'react';

const useMuxChapters = chapters => {
	const [muxChapters, setMuxChapters] = useState([]);
	useEffect(() => {
		if (chapters.length === 0) return;
		const convertedChapters = chapters.map(ch => ({ value: ch.title, startTime: ch.timecode }));
		setMuxChapters(convertedChapters);
	}, [chapters]);
	return muxChapters;
};

export default useMuxChapters;
